import { useMemo } from 'react';
import { ColorChoice } from '../constants/colorConstants';
import { selectClusterColorItems } from '../selectors/clusters';
import { selectCropColorItems } from '../selectors/crops';
import { selectEquipmentColorItems } from '../selectors/equipments';
import { selectTagColorItems } from '../selectors/tags';
import { ColorItem } from '../slices/colors';
import { useAppSelector } from '../store/hooks';

export function useColorChoiceItems(): Record<ColorChoice, ColorItem[]> {
  const clusterColorItems = useAppSelector(selectClusterColorItems);
  const cropColorItems = useAppSelector(selectCropColorItems);
  const equipmentColorItems = useAppSelector(selectEquipmentColorItems);
  const tagColorItems = useAppSelector(selectTagColorItems);

  return useMemo(
    () => ({
      default: [],
      clusters: clusterColorItems,
      crops: cropColorItems,
      equipment: equipmentColorItems,
      tags: tagColorItems,
    }),
    [clusterColorItems, cropColorItems, equipmentColorItems, tagColorItems],
  );
}
